import { initAccordion } from '../../components/accordion';

export default () => {
  const accordions = document.querySelectorAll('[data-accordion-container]');

  if (accordions.length === 0) {
    return;
  }

  accordions.forEach((accordion) => {
    initAccordion(accordion);
  });
};
